import { useLayoutEffect, useRef, type ReactNode, type TextareaHTMLAttributes } from 'react';

import { HeadSign, type Approvals } from './JournalPaper';
import { SHEET_SIGNERS } from './sheetModel';

/** 위험성평가 · TBM 일지(V572 · DOC-136)의 표 한 장 — 제목 줄과 결재란(규격은 일지 종이와 같다). */
export function SheetHead({ title, approvals }: { title: string; approvals?: Approvals }) {
  return (
    <div className="ss-head">
      <h2>{title}</h2>
      <table className="ss-sign">
        <tbody>
          <tr>
            <th rowSpan={2} className="ss-sign-side">
              결<br />재
            </th>
            {SHEET_SIGNERS.map((name) => (
              <th key={name}>{name}</th>
            ))}
          </tr>
          <tr>
            <td>
              <HeadSign tools={approvals?.MANAGER} />
            </td>
            <td>
              <HeadSign tools={approvals?.HEAD} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export function SheetField({ label, children, wide }: { label: string; children: ReactNode; wide?: boolean }) {
  return (
    <label className={`ss-field ${wide ? 'ss-wide' : ''}`}>
      <span>{label}</span>
      {children}
    </label>
  );
}

/**
 * 표 칸의 여러 줄 입력 — 글 길이만큼 높이가 늘어난다. 2줄로 묶어 두면 위험성평가의 감소대책처럼 긴 글이 칸 밖으로
 * 잘려 안 보인다(2026-11-04). 칸 폭이 바뀌면 줄바꿈이 달라지므로 폭이 바뀔 때도 다시 잰다.
 */
export function GrowTextarea(props: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  const ref = useRef<HTMLTextAreaElement | null>(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const fit = () => {
      el.style.height = '0px';
      el.style.height = `${el.scrollHeight + 2}px`;
    };
    fit();
    let width = el.clientWidth;
    const observer = new ResizeObserver(() => {
      if (el.clientWidth === width) return;
      width = el.clientWidth;
      fit();
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [props.value]);
  return <textarea ref={ref} rows={1} {...props} style={{ overflow: 'hidden', ...props.style }} />;
}
